import { FC } from 'react';
import { ErrorBlock } from '@/components/blocks/errors/ErrorBlock/ErrorBlock';
import { RESPONSE_ERROR_PHRASES } from '@/consts/phrases/errorPhrases';
import { Box } from '@mui/material';
import { isArrayWithValues } from '@/utils/fp/array/array';
import { ErrorIconAccessDenied } from '@/assets/theme/default/errorsIcons/ErrorIconAccessDenied';
import { usePhrase } from '@/hooks/general/usePhrase/usePhrase';
import { useQueryParams } from '@/hooks/general/useQueryParams';

interface Error403Props {
    errorPhraseIds?: number[] | null;
}

export const Error403: FC<Error403Props> = ({ errorPhraseIds }) => {
    const { t } = usePhrase();
    const { p } = useQueryParams();

    const queryErrorPhraseIds = p ? (p?.split(',') ?? [p]).map(Number) : [];
    const allErrorPhraseIds = [...queryErrorPhraseIds, ...(errorPhraseIds ?? [])];

    const errorMessage = () =>
        isArrayWithValues(allErrorPhraseIds)
            ? allErrorPhraseIds.map((p, index) => (
                  <Box sx={{ mt: index ? 1 : 0 }} key={p}>
                      {t(p)}
                  </Box>
              ))
            : t(RESPONSE_ERROR_PHRASES.ACCESS_DENIED_DESCRIPTION);

    return (
        <ErrorBlock
            icon={<ErrorIconAccessDenied />}
            title={t(RESPONSE_ERROR_PHRASES.ACCESS_DENIED)}
            text={errorMessage()}
        />
    );
};
